import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../../TheCrypt";
import {TheCryptSoundManager} from "../../sound/TheCryptSoundManager";

export class TheCryptNudgePresentation implements SimplePresentation {
    name: string = "DropInPresentation";

    shouldRun(): boolean {
        return TheCrypt.model.hasNudge.indexOf(true) > -1;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});
        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(2);
        }));
        let counter: number = 0;
        TheCrypt.model.xNudgeMultiplier.forEach((multiplier: number, i: number) => {
            if (multiplier > 0) {
                tl.add(TheCrypt.realArea.allReels[i].reelView.nudge(multiplier, counter), counter * 0.6);
                counter++;
            }
        });

        tl.addLabel("ending");
        tl.to(this, {duration: 0.01});
    }
}